<template>
  <div class="stats">
    <div class="stats__line stats__line--feedback">
      <button @click="share('twitter')">Share on Twitter</button>
    </div>
    <div class="stats__line stats__line--total">
      {{ (globalPoints || '20,000,000+') | number }}
    </div>
    <div class="stats__line stats__line--points">
      {{ points | number }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import share from 'lib/share';

export default {
  computed: mapState({
    globalPoints: state => state.globalPoints,
    points: state => state.points,
  }),
  methods: {
    share,
  },
};
</script>

<style lang="scss" scoped>
.stats {
  color: #888;
  font-size: .875em;
  padding: .8em 1.5em;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;

  @media (max-width: 500px), (max-height: 500px) {
    display: none
  }

  &__line {
    border-bottom: 1px solid #bbb;
    padding: .2rem 0;

    &:last-child {
      border-bottom: none;
    }

    &--total::before {
      content: 'Animals found globally:  ';
    }

    &--points {
      font-weight: 100;
      font-size: 4em;

      &::before {
        content: 'Your points:  ';
        display: block;
        font-size: .25em;
        font-weight: normal;
        margin-bottom: -0.5em;
      }
    }
  }

  a,
  button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font: inherit;
    padding: 0;
    text-decoration: none;

    &:hover {
      color: #444;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Stats.vue?1b94c003